import React from 'react'
import classNames from 'classnames'
import { TooltipV2 } from '@cleartrip/ct-design-components'
import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import Info from '@/assets/icons/InfoIcon'
import { formatCurrency } from '@/utils'
import { isEmpty } from '@/utils/general/browserHelper'
import { getCheapestCardPrice } from '@/utils/srp/helper'
import { useAppSelector } from '@/redux/store/hooks'
import { getSrpSearchData } from '@/redux/slices/srpSlice'
import { ChevronLeft, ChevronRight, Pipe } from '@/assets'
dayjs.extend(customParseFormat)

const DateSelectorComponent = ({
    curDate,
    tabPriceData,
    onUpdateSelectedDate,
    handleArrowClick,
    journeyType,
    showPriceTooltip,
    sortedFilteredCards
}) => {
    const { searchData, srpError, isLoading: isStoreDataLoading, couponData } = useAppSelector(getSrpSearchData)
    const handleDateClick = date => {
        onUpdateSelectedDate(date)
    }

    const DateTabBlock = tabPriceData.map((element, index) => {
        const selectedDate = element.date === dayjs(curDate, 'DD/MM/YYYY').format('DD-MM-YYYY')

        // setting the element pr
        if (selectedDate && !isEmpty(searchData)) {
            element.pr = getCheapestCardPrice(sortedFilteredCards?.[journeyType === 'onward' ? 0 : 1], searchData) ?? element.pr
        }

        const selectedClassParent = classNames('flex flex-column flex-middle flex-1 pb-3', {
            'bb-2 bc-neutral-900': selectedDate,
            'c-pointer': !selectedDate
        })
        const selectedClassDate = classNames(
            'm-0 fs-14 lh-20 fw-600 mb-1',
            { 'c-neutral-700': !selectedDate },
            { 'c-neutral-900': selectedDate }
        )
        const selectedClassPrice = classNames(
            'm-0 fs-12 lh-16 fw-500',
            { 'c-neutral-700': !selectedDate && !element.isCheapest },
            { 'c-neutral-900': selectedDate },
            { 'intl-success': element.isCheapest && !selectedDate }
        )

        const InfoTooltip = () => (
            <TooltipV2
                position="top"
                labelContainer={
                    <span style={{width: "12px", height: "100%", display: "flex", alignItems: "center", left: "7px", position: "absolute"}}>
                        <Info className="c-neutral-400" height={'12'} width={'12'}/>
                    </span>
                }
                styleConfig={{
                    tooltipContainer: {css: {width: "203px", padding: "16px", bottom: '15px'}},
                    tooltipArrowContainer: {css: {left: "5px", top: "unset", bottom: "10px"}}
                }}
            >
                <p>This price is based on the filters applied by you for this date.</p>
            </TooltipV2>
        )

        return (
            <React.Fragment key={element.date}>
                {!index && (
                    <span
                        style={{
                            height: '1px',
                            paddingBottom: '12px',
                            border: '1px solid #E7E7E7',
                            borderWidth: '1px 0px',
                            marginLeft: '10px'
                        }}
                    >
                        <Pipe />
                    </span>
                )}
                <div
                    className={selectedClassParent}
                    style={{ marginBottom: selectedDate ? '-1px' : '' }}
                    onClick={() => !selectedDate && handleDateClick(element.date)}
                    role="button"
                    data-testid="dateCard"
                >
                    <p className={selectedClassDate}>
                        {dayjs(element.date, 'DD-MM-YYYY').format('ddd, DD MMM')}
                    </p>
                    <div className="flex flex-middle">
                        <p className={selectedClassPrice}>
                            {element.pr !== '-' ? formatCurrency(element.pr) : '-'}
                        </p>
                        <span className="">
                            {selectedDate && showPriceTooltip && element.pr !== '-' ? (
                                <InfoTooltip/>
                            ) : null}
                        </span>
                    </div>
                </div>
                <span
                    style={{
                        height: '1px',
                        paddingBottom: '12px',
                        border: '1px solid #E7E7E7',
                        borderWidth: '1px 0px',
                        marginRight: `${index == 6 ? '10px' : ''}`
                    }}
                >
                    <Pipe />
                </span>
            </React.Fragment>
        )
    })

    return (
        <div className="flex w-100p mb-6">
            <span
                style={{
                    paddingTop: ' 2px',
                    paddingBottom: '5px',
                    height: '24px',
                    width: '24px',
                    zIndex: '20'
                }}
                onClick={e => {
                    handleArrowClick('left')
                }}
                data-testid="chevLeft"
            >
                <ChevronLeft
                    width="24"
                    stroke="#999999"
                    className={classNames('mt-2 c-pointer')}
                    data-direction="left"
                    style={{ marginTop: '6px' }}
                />
            </span>
            <div className=" flex-1 flex flex-around bb bs-border px-4 nmx-4 h-12" style={{color: "#e6e6e6"}}>{DateTabBlock}</div>

            <span
                style={{
                    paddingTop: ' 2px',
                    paddingBottom: '5px'
                }}
                onClick={e => {
                    handleArrowClick('right')
                }}
                data-testid="chevRight"
            >
                <ChevronRight
                    width="24"
                    stroke="#999999"
                    className={classNames('mt-2 c-pointer')}
                    data-direction="right"
                    style={{ marginTop: '6px' }}
                />
            </span>
        </div>
    )
}

export default DateSelectorComponent
